// Contrôle de SIRET côté navigateur. Même règle que
// functions/_lib/contact-core.js (le serveur ne bloque jamais sur un SIRET,
// il le signale à l'équipe ; ici on évite surtout les fautes de frappe).

export const siretDigits = (raw) => String(raw ?? "").replace(/[\s.\-]/g, "");

/** { empty, digits, valid } — « vide » est toujours acceptable (champ facultatif). */
export function checkSiret(raw) {
  const digits = siretDigits(raw);
  if (!digits) return { empty: true, digits, valid: true };
  if (!/^\d{14}$/.test(digits)) return { empty: false, digits, valid: false };
  let sum = 0;
  for (let i = 0; i < 14; i += 1) {
    let d = Number(digits[13 - i]);
    if (i % 2 === 1) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
  }
  let valid = sum % 10 === 0;
  // Exception La Poste (SIREN 356000000) : somme des chiffres divisible par 5.
  if (!valid && digits.startsWith("356000000")) {
    valid = digits.split("").reduce((a, c) => a + Number(c), 0) % 5 === 0;
  }
  return { empty: false, digits, valid };
}
